import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';

import NavBar from '../Navigation/NavBar';
import Aside from '../Navigation/Aside';
import Footer from '../Navigation/Footer';

import './index.scss';

const Layout = ({ children }) => {
  const [asideMobileActive, setAsideMobileActive] = useState(false);

  const handleMobileToggle = () => {
    document.documentElement.classList.toggle('has-aside-mobile-expanded');
    setAsideMobileActive(!asideMobileActive);
  };

  const { displayFooter } = useSelector(
    (state) => ({
      displayFooter: state.preferences.displayFooter,
    }),
    shallowEqual
  );

  return (
    <>
      <NavBar
        handleMobileToggle={handleMobileToggle}
        asideMobileActive={asideMobileActive}
      />
      <Aside handleMobileToggle={handleMobileToggle} />
      <div className={`layout ${displayFooter ? '' : 'footer-hidden'}`}>
        {children}
      </div>
      {displayFooter && <Footer />}
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
